import { render, staticRenderFns } from "./CobranzaView.vue?vue&type=template&id=94b64cfa&scoped=true"
import script from "./CobranzaView.vue?vue&type=script&lang=js"
export * from "./CobranzaView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94b64cfa",
  null
  
)

export default component.exports